import { jsPDF } from 'jspdf';
import { DeliveryDTO } from '../../../api/generated';
import { downloadMultipleDeliveryCSV } from './csvGenerator';
import { generateDeliveriesPDF, PdfGenerationOptions } from './pdfGenerator';

export interface ExportOptions<T = undefined> {
  deliveries: DeliveryDTO[];
  // without extension
  filename: string;
  capturer_id: string;
  exportOptions?: T;
}

export async function exportMultipleDeliveriesPDF(props: ExportOptions<PdfGenerationOptions>): Promise<void> {
  const { deliveries, filename, capturer_id, exportOptions } = props;
  const doc = await generateDeliveriesPDF(deliveries, capturer_id, exportOptions);
  doc.setProperties({ title: filename });
  openPrintDialog(doc, filename);
}

export function openPrintDialog(doc: jsPDF, filename: string): void {
  const pdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(pdfBlob);

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = pdfUrl;

  iframe.onload = () => {
    const contentWindow = iframe.contentWindow;
    if (contentWindow) {
      contentWindow.document.title = filename;
      contentWindow.print();

      const cleanup = () => {
        // ensure print dialog is fully closed
        setTimeout(() => {
          if (iframe.parentNode) {
            document.body.removeChild(iframe);
          }
          URL.revokeObjectURL(pdfUrl);
          window.removeEventListener('focus', cleanup);
        }, 100);
      };

      // Cleanup when focus returns to main window (print dialog closed)
      window.addEventListener('focus', cleanup, { once: true });
    }
  };

  document.body.appendChild(iframe);
}

export async function exportMultipleDeliveriesCSV(props: ExportOptions): Promise<void> {
  const { deliveries, filename, capturer_id } = props;
  await downloadMultipleDeliveryCSV(deliveries, capturer_id, filename);
}
